import { render, staticRenderFns } from "./puContractDetail.vue?vue&type=template&id=ad55bf9e"
import script from "./puContractDetail.vue?vue&type=script&lang=js"
export * from "./puContractDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports